import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
  CopyLink,
  CopyTitle,
  InviteLinkContainer,
  InviteLinkTerms,
  InviteLinkTitle,
  ChainIcon,
  CreateLinkButton,
  TermsAndConditionsContainer,
  Heading,
  TextWrapper,
  ChainTextWrapper,
  ButtonWrapper,
  TopWrapper,
  Title,
} from "./InviteLink.style";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";
import { Modal } from "antd";
// import { FootballIcon } from "@assets";

const InviteLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [textToCopy, setTextToCopy] = useState("");

  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const { invite_link_rule } = useSelector((state) => state.app.settings);

  const inviteLinkRule =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? invite_link_rule?.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? invite_link_rule?.text_mm
        : invite_link_rule?.text_ch;

  const getInviteLink = () => {
    setLoading(true);
    api
      .postReferral()
      .then(({ referral_id }) => {
        const domain = window.location.hostname;
        setLoading(false);
        setTextToCopy(`${domain}/register?referral_id=${referral_id}`);
        setIsOpen(true);
      })
      .catch((errorMsg) => {
        setLoading(false);
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  };

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsOpen(false);
        showAlert({
          message: t("common.copied"),
          successCallback: goBack,
        });
      })
      .catch((error) => {
        //create input or text area
        const input = document.createElement("input");
        input.setAttribute("value", textToCopy);
        document.body.appendChild(input);
        input.select();
        const result = document.execCommand("copy");
        document.body.removeChild(input);
        if (result) {
          showAlert({
            message: t("common.copied"),
            successCallback: goBack,
          });
        } else {
          alert("Failed to copy to clipboard.");
        }
        console.error("Failed to copy: ", error);
      });
  };

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.PROFILE}`);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const renderTop = () => (
    <TopWrapper>
        {/* <FootballIcon /> */}
        <Title>{t("profile.inviteLinkTerms")}</Title>
        {/* <FootballIcon /> */}
    </TopWrapper>
  );

  return (
    <>
      <Topbar title={t("profile.inviteLink")} goBack={goBack} shadow={false} />
      <InviteLinkContainer>
        <Heading>
          <ChainTextWrapper>
            <ChainIcon />
            <TextWrapper>
              <InviteLinkTitle>
                {t("profile.inviteLinkSubtitle")}
              </InviteLinkTitle>
            </TextWrapper>
          </ChainTextWrapper>

          <ButtonWrapper>
            <CreateLinkButton
              language={userPreferedLanguage}
              onClick={getInviteLink}
              loading={loading}
            >
              {t("common.create")}
            </CreateLinkButton>
          </ButtonWrapper>
        </Heading>

        {renderTop()}
        <TermsAndConditionsContainer>
          <InviteLinkTerms
            dangerouslySetInnerHTML={{ __html: inviteLinkRule }}
          />
        </TermsAndConditionsContainer>
      </InviteLinkContainer>
      <Modal
        open={isOpen}
        closable={false}
        style={{
          textAlign: "center",
        }}
        centered={true}
        onCancel={() => setIsOpen(false)}
        cancelText={t("common.cancel")}
        onOk={handleCopyClick}
        okText={t("common.copy")}
        width={326}
      >
        <CopyTitle>{t("profile.inviteLinkModalContent")}</CopyTitle>
        <CopyLink>{textToCopy}</CopyLink>
      </Modal>
      <Alert />
    </>
  );
};

export default InviteLink;
